/* Packages */
import React from 'react';
import { render } from 'react-dom';

/* utilities */
import { parseDataToProps } from '~/utilities';

const productSearchNodes = Array.from(document.querySelectorAll('.product-search'));
if (productSearchNodes.length) {
    import(/* webpackChunkName: "ProductSearch" */ './components/ProductSearch').then(({ default: ProductSearch }) => {
        productSearchNodes.forEach((node) => render(<ProductSearch {...parseDataToProps(node.dataset)} />, node));
    });
}

